import { ReactElement } from 'react';
import { format } from 'date-fns';
import DetailCard from '../../../components/DetailCard';
import { getChannel } from 'utils/channelNamesGridded';

function RunSummary(props: { run: any; calibration: any; calibrationLoading: boolean }): ReactElement {
  const { run, calibration, calibrationLoading } = props;
  const date = run ? new Date(run.run_ts_tz || run.run_ts) : null;

  // Calculate distance using wheel circumference from calibration and wheel revolutions
  let distanceText = '0 km';

  if (calibrationLoading) {
    distanceText = 'Loading...';
  } else {
    const distances = getChannel(run.data_gridded, 'Distance_km', calibration);
    distanceText = distances ? `${distances[distances.length - 1].toFixed(2)} km` : '? km';
  }

  return (
    <div className="cr-flex cr-flex-col cr-gap-8 md:cr-flex-row">
      <DetailCard label="Description">{run.description}</DetailCard>
      <DetailCard label="Date">{date && format(date, 'yyyy-MM-dd')}</DetailCard>
      <DetailCard label="Time of Day">{date && format(date, 'pp')}</DetailCard>
      <DetailCard label="distance">{distanceText}</DetailCard>
    </div>
  );
}

export default RunSummary;
